import React from "react";
import { BsBarChartFill } from "react-icons/bs";
import { FaPlus, FaSortUp, FaUserGroup } from "react-icons/fa6";
import { HiPresentationChartLine } from "react-icons/hi";

import Card from "./ProgressCard";

const ProgressData = () => {
  const cardData = [
    {
      title: "Experian",
      number: "750",
      icon: <HiPresentationChartLine className="icons" />,
      dis_number: "560",
      status: "Just updated",
      pts: "190pts",
      pts_icons: <FaSortUp />,
    },
    {
      title: "Equifax",
      number: "760",
      icon: <BsBarChartFill className="icons" />,
      dis_number: "500",
      status: "Just updated",
      pts: "120pts",
      pts_icons: <FaSortUp />,
    },
    {
      title: "TransUnion",
      number: "763",
      icon: <FaUserGroup className="icons" />,
      dis_number: "500",
      status: "Just updated",
      pts: "183pts",
      pts_icons: <FaSortUp />,
    },
    {
      title: "Available Borrowing Power",
      number: "$80,000",
      icon: <BsBarChartFill className="icons" />,
      status: "Since last week",
      pts: "6.8%",
      pts_icons: <FaPlus />,
    },
  ];

  return (
    <div className="row dash_card">
      {cardData.map((card, index) => (
        <div className="col-lg-6 col-md-6 col-sm-6" key={index}>
          <Card key={index} {...card} />
        </div>
      ))}
    </div>
  );
};

export default ProgressData;
